import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { sendChangeEmail } from "../../../services/memberServices";

import { useUserContext } from "../../../contexts/userContext";

import useEmailVerification from "../../../hooks/useEmailVerification";

import StickyHeader from "../../../components/Layout/StickyHeader";
import HorizontalRule from "../../../components/Rule/Horizontal";
import CommonButton from "../../../components/Button";
import CertEmailPopup from "../../../components/Popup/CertEmail";

type Props = {};

export default function MyInfoChangeEmail(props: Props) {
  const navigate = useNavigate();
  const [popup, setPopup] = useState<string>("");
  const [user] = useUserContext();
  const [
    { isComplete: isCompleteEmail, validate: validateEmail },
    emailVerificationComponent,
  ] = useEmailVerification({
    label: "변경하실 새로운 이메일을 입력해주세요",
    sendEmail: sendChangeEmail,
    onSuccess: () => {
      navigate("/myinfo", {
        state: {
          error:
            "확인 이메일이 발신되었어요.\n변경된 이메일은 메일 확인 후\n재로그인하면 적용됩니다.",
        },
      });
    },
    useFindPassword: false,
  });

  return (
    <div className="min-h-screen flex flex-col justify-between z-30">
      <div className="px-5 ">
        <StickyHeader
          title="이메일 변경"
          onBackClick={() => navigate("/myinfo")}
        />
        <div className=" text-3xl whitespace-pre-line font-normal pb-3">
          {"등록된 이메일\n"}
          <strong>변경</strong>을 도와드릴게요
        </div>
        <HorizontalRule className="bg-black" />
        <div>
          <div className="label-grey-medium">현재 아이디(이메일)</div>
          <div className=" text-lg font-medium">{user.email}</div>
        </div>
        <HorizontalRule />
        {emailVerificationComponent}
      </div>
      <CommonButton
        className="w-full rounded-none h-bottom-button font-medium"
        validation={!isCompleteEmail}
        onClick={() => {
          if (validateEmail()) {
            setPopup("sendEmailNotice");
          }
        }}
      >
        이메일 변경
      </CommonButton>

      <CertEmailPopup popup={popup} onClose={() => setPopup("")} />
    </div>
  );
}
